/**
 * Accessory add-ons: lets a customer opt into paid accessories (mounting base, cable,
 * smart plug, smart meter) alongside a host battery purchase, from the checkbox list
 * rendered by snippets/sb-accessory-addons.liquid.
 *
 * Unlike gift-with-purchase.js, there is no cross-page reconciliation here — the
 * checkbox selection only exists on this page at submit time, so this file is only
 * ever loaded from within that snippet, and only when the current product actually
 * has add-on rows. Deliberately independent of product-form.js (Dawn-native): this
 * attaches its own listener to the existing form rather than modifying it.
 */
(function () {
  'use strict';

  function addonRows() {
    return Array.prototype.slice.call(document.querySelectorAll('.sb-addon-item'));
  }

  function selectedItems() {
    return addonRows()
      .map(function (row) {
        var checkbox = row.querySelector('.sb-addon-item__checkbox');
        if (!checkbox || checkbox.disabled || !checkbox.checked) return null;
        return { id: parseInt(checkbox.dataset.variantId, 10), quantity: 1 };
      })
      .filter(Boolean);
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error('sb-accessory-addons: request to ' + url + ' failed');
      return res.json();
    });
  }

  function refreshCartIconBubble() {
    return fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById('cart-icon-bubble');
        var target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(function () {
        /* non-critical, cart-items/cart-drawer-items still refresh via cartUpdate below */
      });
  }

  function refreshMainCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return Promise.resolve();

    return fetch(window.routes.cart_url + '?section_id=' + encodeURIComponent(footer.dataset.id))
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('#main-cart-footer .js-contents');
        var target = footer.querySelector('.js-contents');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function addSelectedAccessories() {
    var items = selectedItems();
    if (items.length === 0) return Promise.resolve(null);

    return postJSON(window.routes.cart_add_url, { items: items }).catch(function (error) {
      // A failed accessory add shouldn't block the host product purchase that already
      // succeeded (or is in flight) — log and move on.
      console.error(error);
      return null;
    });
  }

  function handleAddToCartSubmit() {
    addSelectedAccessories().then(function (result) {
      if (!result) return;
      var tasks = [refreshCartIconBubble(), refreshMainCartFooter()];
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        tasks.push(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'accessory-addons' }));
      }
      return Promise.all(tasks);
    });
  }

  function initVariantSelects() {
    addonRows().forEach(function (row) {
      var select = row.querySelector('[data-addon-variant-select]');
      var checkbox = row.querySelector('.sb-addon-item__checkbox');
      var priceEl = row.querySelector('.sb-addon-item__price');
      if (!select || !checkbox) return;

      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        checkbox.dataset.variantId = option.value;
        if (priceEl && option.dataset.price) {
          priceEl.textContent = (Number(option.dataset.price) / 100).toLocaleString('nl-NL', {
            style: 'currency',
            currency: 'EUR',
          });
        }
      });
    });
  }

  function init() {
    initVariantSelects();

    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', handleAddToCartSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exposed so assets/sb-product.js ("Nu kopen") can await this directly before
  // redirecting to checkout, the same way it already awaits window.SBGiftSync.
  window.SBAddSelectedAccessories = addSelectedAccessories;
})();
